import type { FaireProductEntity } from "../../entity_types/product";

export const p_rsbw4dytdt: FaireProductEntity = {
  token: "p_rsbw4dytdt",
  type: "product",
  name: "Volcano Agate Crescent Moon",
  brandToken: "b_ciwhgi8nfq",
  brandName: "The Crystal Tabby",
  imageUrl:
    "https://cdn.faire.com/fastly/ba4103588eba9069837159aad1307b47180967e0958db619b6cf5e718f55ba3b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/562cbdcd101a1d68f25cf37415e527c59ed79dd47b5c3088acdff46fc72c86cc.jpeg",
    "https://cdn.faire.com/fastly/f4977ace58c5df3f358705ae1bff7eb5dbdf4df5b8c121c72f3784fce122f2a0.jpeg",
    "https://cdn.faire.com/fastly/1f6497645d53c225ef7f04434a4951ba4436bb2b723c67ce27616c85e63d8ced.jpeg",
    "https://cdn.faire.com/fastly/f7bdb8d9617d11273da9c31440bd46f50c5836b58214a46a19dbc9c995f26a36.jpeg",
    "https://cdn.faire.com/fastly/7cea93001cdbdf5cb70ac35f7f750984b7cc5575cfcc08abb0660032935cedc8.jpeg",
    "https://cdn.faire.com/fastly/067a0a0b8457d1fcaad926477fe1cc71a493f349b1ecdb6c85229878d347e102.jpeg",
    "https://cdn.faire.com/fastly/4a3944cc4d4496d1f79771b7e951c0d8f1e1e74d1496d1ac156cc383a4ef4c51.jpeg",
    "https://cdn.faire.com/fastly/43e4faff47c02d1441ddddf3e9b4ae5a2eb5121459f8a3ebfbf3ea53ead6f87e.jpeg",
    "https://cdn.faire.com/fastly/97c9f64804ed2725e3b657e3e285e4e510eec0250c6f37640a382a33ba60e078.jpeg",
    "https://cdn.faire.com/fastly/3d3316f89027a9cf0302eaeb080624cb6097d94bd5bd351de1a5215884f79d97.jpeg",
  ],
  priceDollars: 19.4,
  description:
    "This striking volcano agate crescent moon features rich, earthy tones with natural banding and unique patterns. Each piece is carefully shaped and polished to a smooth finish, highlighting the intricate details and depth within the stone.\n\nThe crescent moon shape adds a mystical and modern touch, making it a beautiful display piece for crystal lovers, home décor, or spiritual collections.\n\nProduct Details\n• Volcano agate crescent moon\n• Approximate size: 4 inches\n• Smooth, polished finish\n• Warm earthy tones with natural banding\n• Carved crescent moon shape\n• Natural stone — variations in color, pattern, and shape are expected",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:19.925Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
